import {remCalc} from '_themeUtils'
//import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const shopByLook = {
    ShopByLook: {
        baseStyle: () => ({
            container: {
                w: '100%',
                gap: {base: remCalc(20), md: `${remCalc(0)} ${remCalc(20)}`},
                templateColumns: {base: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))'},
                templateAreas: {
                    base: `"image" "title" "tiles"`,
                    md: `"breadcrumb breadcrumb" "title title" "image tiles"`,
                },
            },
            breadCrumbContainer: {
                gridArea: 'breadcrumb',
                w: '100%',
                alignItems: 'flex-start',
                pl: {base: remCalc(30)},
                // CSS-only visibility avoids the flash caused by useViewport's client-side hydration delay
                display: {base: 'none', md: 'flex'},
            },
            imageContainer: {
                gridArea: 'image',
                w: '100%',
                minW: 0,
                cursor: 'pointer',
                // cursor: `url(${getAssetUrl('static/img/global/zoom-in-new.png')}) 16 16, zoom-in`,
            },
            title: {
                gridArea: 'title',
                textStyle: 'paragraphMd',
                fontWeight: 400,
                textAlign: 'center',
                w: '100%',
                py: {base: remCalc(5)},
                display: {base: 'block', md: 'none'},
            },
            tilesContainer: {
                gridArea: 'tiles',
                w: '100%',
                minW: 0,
                alignSelf: 'flex-start',
                gap: remCalc(20),
                templateColumns: {base: 'minmax(0, 1fr)', md: 'repeat(1, minmax(0, 1fr))', xl: 'repeat(2, minmax(0, 1fr))'},
                pl: {base: remCalc(32), md: 0},
                pr: {base: remCalc(32), md: remCalc(20)},
                pb: {base: remCalc(30)},
            },
        }),
    },
}

export default shopByLook
